import { useEffect, useMemo } from 'react';

import { useSelectedEmployeeContext } from '~/components/SelectedEmployee/context';

type PropsType = {
  employeeId?: number;
};

type UsePathEmployeeIdAsSelectedEmployeeIdOutput = {
  selectedEmployeeId: number;
  isOutOfSync: boolean;
  isSelectedEmployeeLoggedInUser: boolean;
};

export const useEmployeeIdAsSelectedEmployeeId = (
  props: PropsType,
): UsePathEmployeeIdAsSelectedEmployeeIdOutput => {
  const { employeeId } = props;

  const {
    selectedEmployeeId,
    setSelectedEmployeeId,
    isSelectedEmployeeLoggedInUser,
  } = useSelectedEmployeeContext();

  const isOutOfSync = useMemo(
    () => !!employeeId && employeeId !== selectedEmployeeId,
    [employeeId, selectedEmployeeId],
  );

  // Sync paramsEmployeeId to localStorage
  useEffect(() => {
    if (!!employeeId && isOutOfSync) {
      setSelectedEmployeeId(employeeId);
    }
  }, [selectedEmployeeId, setSelectedEmployeeId, employeeId, isOutOfSync]);

  return {
    isOutOfSync,
    selectedEmployeeId,
    isSelectedEmployeeLoggedInUser,
  };
};
